import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Layout' })((theme) => ({
    root: {
        position: 'relative',
        minWidth: 1280,
        width: '100vw',
        height: '100vh',
        overflow: 'auto',
        background: '#FFFFFF',
        color: '#232323',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            minWidth: 0
        }
    },
    noise: {
        content: '""',
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        backgroundImage: 'url(/static/img/landing/noise.svg)',
        backgroundRepeat: 'repeat',
        backgroundSize: '85% auto',
        mixBlendMode: 'multiply',
        opacity: 0.6,
        pointerEvents: 'none'
    },
    header: {
        top: 0,
        zIndex: theme.zIndex.drawer + 1,
        position: 'sticky'
    },
    content: {
        zIndex: 1,
        position: 'relative',
        maxWidth: 1280,
        margin: '0 auto',
        boxSizing: 'border-box',
        padding: '0 16px'
    },
    leftBg: {
        content: '""',
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundImage: 'url(/static/img/landing/left-bg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'left top',
        zIndex: 0,
        pointerEvents: 'none'
    },
    rightBg: {
        content: '""',
        position: 'fixed',
        top: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        backgroundImage: 'url(/static/img/landing/right-bg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'right top',
        zIndex: 0,
        pointerEvents: 'none'
    }
}));
